/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Today_Insight_ActionInputs */

const en_us2_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`View exercise`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Ask your trainer`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`View plan`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Do the check-in`);
	return /** @type {LocalizedString} */ (`Open`)
	
};

const pt_br2_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`Ver exercício`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Perguntar ao personal`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`Ver plano`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Fazer o check-in`);
	return /** @type {LocalizedString} */ (`Abrir`)
	
};

const es_419_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`Ver ejercicio`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Preguntar al entrenador`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`Ver plan`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Hacer el check-in`);
	return /** @type {LocalizedString} */ (`Abrir`)
	
};

const pt_pt2_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`Ver exercício`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Perguntar ao treinador`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`Ver plano`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Fazer o check-in`);
	return /** @type {LocalizedString} */ (`Abrir`)
	
};

const fr_fr2_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`Voir l'exercice`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Demander au coach`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`Voir le programme`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Faire le bilan`);
	return /** @type {LocalizedString} */ (`Ouvrir`)
	
};

const de_de2_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`Übung ansehen`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Coach fragen`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`Plan ansehen`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Check-in machen`);
	return /** @type {LocalizedString} */ (`Öffnen`)
	
};

const it_it2_today_insight_action = /** @type {(inputs: Today_Insight_ActionInputs) => LocalizedString} */ (i) => {
	if (i?.type === "open_exercise") return /** @type {LocalizedString} */ (`Vedi esercizio`);
	if (i?.type === "ask_trainer") return /** @type {LocalizedString} */ (`Chiedi al coach`);
	if (i?.type === "open_plan") return /** @type {LocalizedString} */ (`Vedi scheda`);
	if (i?.type === "open_checkin") return /** @type {LocalizedString} */ (`Fai il check-in`);
	return /** @type {LocalizedString} */ (`Apri`)
	
};

/**
* | type | output |
* | --- | --- |
* | "open_exercise" | "View exercise" |
* | "ask_trainer" | "Ask your trainer" |
* | "open_plan" | "View plan" |
* | "open_checkin" | "Do the check-in" |
* | * | "Open" |
*
* @param {Today_Insight_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_insight_action = /** @type {((inputs: Today_Insight_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Insight_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_insight_action(inputs)
	if (locale === "es-419") return es_419_today_insight_action(inputs)
	if (locale === "pt-PT") return pt_pt2_today_insight_action(inputs)
	if (locale === "fr-FR") return fr_fr2_today_insight_action(inputs)
	if (locale === "de-DE") return de_de2_today_insight_action(inputs)
	if (locale === "it-IT") return it_it2_today_insight_action(inputs)
	return en_us2_today_insight_action(inputs)
});
export { today_insight_action as "today.insight_action" }